import { Box, Card } from "@mui/material";

const SkeletonDayCell = () => (
  <Card
    sx={{
      padding: 1,
      minHeight: 120,
      background: "#f5f5f5",
      border: "1px solid #e0e0e0",
      display: "flex",
      flexDirection: "column",
      gap: 1,
    }}
  >
    {/* Day number skeleton */}
    <Box
      sx={{
        height: 16,
        width: "30%",
        background: "#e0e0e0",
        borderRadius: 1,
        animation: "pulse 1.5s ease-in-out infinite",
      }}
    />

    {/* Call count skeleton */}
    <Box
      sx={{
        height: 12,
        width: "50%",
        background: "#e0e0e0",
        borderRadius: 1,
        animation: "pulse 1.5s ease-in-out infinite",
        animationDelay: "0.2s",
      }}
    />

    {/* Project item skeleton 1 */}
    <Box sx={{ gap: 0.5, display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          height: 12,
          width: "60%",
          background: "#e0e0e0",
          borderRadius: 1,
          animation: "pulse 1.5s ease-in-out infinite",
          animationDelay: "0.4s",
        }}
      />
      <Box
        sx={{
          height: 10,
          width: "40%",
          background: "#e0e0e0",
          borderRadius: 1,
          animation: "pulse 1.5s ease-in-out infinite",
          animationDelay: "0.6s",
        }}
      />
    </Box>

    {/* Project item skeleton 2 */}
    <Box sx={{ gap: 0.5, display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          height: 12,
          width: "55%",
          background: "#e0e0e0",
          borderRadius: 1,
          animation: "pulse 1.5s ease-in-out infinite",
          animationDelay: "0.8s",
        }}
      />
      <Box
        sx={{
          height: 10,
          width: "35%",
          background: "#e0e0e0",
          borderRadius: 1,
          animation: "pulse 1.5s ease-in-out infinite",
          animationDelay: "1s",
        }}
      />
    </Box>

    <style>{`
      @keyframes pulse {
        0%, 100% {
          opacity: 1;
        }
        50% {
          opacity: 0.6;
        }
      }
    `}</style>
  </Card>
);

export default SkeletonDayCell;
